import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
// import { SearchMd } from "../../icons/SearchMd";
import {
  commonFetchData,
  updateQueryParams,
} from "../../utils/commanFunctions";
import SingleCardNew from "../common/SingleCardNew";
import Home from "../Home/Home";
import { useLocation, useNavigate, useNavigationType } from "react-router";
import NoDataFoundSmall from "../common/NoDataFoundSmall";
import Spinner from "../spinner/Spinner";
// import NewFilter from "../common/Filters/NewFilter";
import { Header } from "../common/Header";
import SeeAllButton from "../common/Buttons/SeeAllButton";
import configs, { translations } from "../../contentConfig";
import PersonalizedCard from "../Personalized/PersonalizedCard";
import SearchOnMap from "./SearchOnMap";
import FavoritesGrid from "./FavoritesGrid";
import SmallMapCard from "./SmallMapCard";
import { trackExploreMore } from "../../utils/FunctionsForGa";
// import PersonalizedCard from "../Personalized/PersonalizedCard";
// import { ViewButton } from "../common/Buttons/ViewButton";

const layoutColumn = configs["explore"]?.["layoutColumn"] || [];
const showSellAll = configs?.["explore"]?.["hideColumnShowAllButton"] ?? true;
const dimensions = configs?.["explore"]?.["cardDimension"] || {};
const showPersonalizeYourStay =
  configs?.["explore"]?.["personaliseYourStay"]?.visible || false;
const personalizeYourStayPosition =
  configs?.["explore"]?.["personaliseYourStay"]?.position;

const showSearchOnMap = configs?.["explore"]?.["searchOnMap"]?.visible || false;
const showSearchOnMapPosition = configs?.["explore"]?.["searchOnMap"]?.position;

const showFavoritesGrid =
  configs?.["explore"]?.["favoritesGrid"]?.visible || false;
const favoritesGridPosition = configs?.["explore"]?.["favoritesGrid"]?.position;

const cardTypes = configs?.cards?.cardTypes || ["single", "grid"];
const allowGridCard = cardTypes.includes("grid");

const getGroupData = (e = {}) => ({
  name: e.name,
});

export const Explore = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // const apiParams = params.get('apiParams')
  const apiParams =
    params.get("apiParams") || localStorage.getItem("apiParams");
  const is_embedded_in_parent = localStorage.getItem("is_embedded_in_parent");

  const BATCH_SIZE = 1;
  const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
  const observerRef = useRef(null);
  const listContainerRef = useRef(null);

  const [exploreData, setExploreData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState({
    display_value: "All",
    query_value: "all",
  });

  const navigate = useNavigate();
  const inputRef = useRef(null);

  const fetchExploreData = useCallback(
    async (searchQuery = "") => {
      try {
        setIsLoading(true);
        const endpoint = searchQuery
          ? `/planner/places-events/groups/?q=${searchQuery}`
          : `/planner/places-events/groups/${apiParams ? "?" + apiParams : ""}`;

        const placesResponse = await commonFetchData(endpoint, {
          req: "get",
          onErrorData: {},
        });

        setExploreData(placesResponse.length > 0 ? placesResponse : []);
        setNoData(placesResponse.length === 0);
      } catch (error) {
        console.error("Data fetching error:", error);
        setNoData(true);
      } finally {
        setIsLoading(false);
      }
    },
    [apiParams]
  );

  // useEffect(() => {
  //   fetchExploreData();
  // }, [fetchExploreData]);

  const handleSearch = useCallback(
    (e) => {
      e?.stopPropagation();
      const text = inputRef.current?.value?.trim() || "";
      fetchExploreData(text);
    },
    [fetchExploreData]
  );

  const handleNavigate = useCallback(
    (e, url) => {
      e?.stopPropagation();
      navigate(url);
    },
    [navigate]
  );

  const headerData = useMemo(
    () => ({
      title: translations?.exploreHeaderTitle || "EXPLORE",
      goBackToParent: window.GoBackToParent,
      // buttonText: "Map",
      // buttonUrl: "/?path=map",
      // eventType: "INNSPIRE_GO_HOME",
      // eventData: {}
    }),
    []
  );

const combinedRenderList = useMemo(() => {
  const list = [];

  const insertAt = (arr, index, item) => {
    const newArr = [...arr];
    newArr.splice(index, 0, item);
    return newArr;
  };

  // Convert exploreData into items
  let baseList = exploreData.map((item, i) => ({
    type: "data",
    key: `data-${i}`,
    data: item,
    index: i,
  }));

  // Insert custom components
  if (exploreData.length > 1) {
    if (showSearchOnMap) {
      baseList = insertAt(baseList, showSearchOnMapPosition, {
        type: "custom",
        key: "searchMap",
        component: <SearchOnMap />,
      });
    }

    if (showPersonalizeYourStay) {
      baseList = insertAt(baseList, personalizeYourStayPosition, {
        type: "custom",
        key: "personalize",
        component: <PersonalizedCard />,
      });
    }
  }


  return baseList;
}, [
  exploreData,
  showSearchOnMap,
  showSearchOnMapPosition,
  showPersonalizeYourStay,
  personalizeYourStayPosition,
  showFavoritesGrid,
  favoritesGridPosition,
]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisibleCount((prev) =>
            Math.min(prev + 1, combinedRenderList.length)
          );
        }
      },
      {
        threshold: 0.1,
        rootMargin: '-100px 0px',
       }
    );

    const current = observerRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.disconnect();
    };
  }, [combinedRenderList.length, visibleCount]);

  const renderExploreSection = useCallback(
    (e, i) => {
      // {console.log("eeeeeeee", e)}

      const isFull = layoutColumn.includes(
        e.name?.toLowerCase().replace(/\s+/g, " ").trim()
      );
      return (
        <>
          {isFull ||
            (exploreData.length === 1 && (
              <>
                {e?.event_or_place_list.length > 0 && (
                  <div
                    style={{ width: "100%" }}
                    className=" !h-[280px] mt-4 mb-8"
                  >
                    <SmallMapCard
                      locations={e.event_or_place_list}
                      mapHeight="280px"
                    />
                  </div>
                )}
              </>
            ))}

          {/* {showPersonalizeYourStay && personalizeYourStayPosition === i && (
            <PersonalizedCard />
          )} */}
          {/* {showSearchOnMap && showSearchOnMapPosition === i && <SearchOnMap />} */}

          <div
            key={i}
            className={`places-bg flex flex-col items-start gap-${
              isFull ? "8" : "4"
            } px-4 py-0 self-stretch w-full relative flex-[0_0_auto] search`}
            style={{
              ...(!isFull && exploreData.length !== 1
                ? { padding: "24px 0px 32px 16px" }
                : {}),
              ...(i === 0 && exploreData.length !== 1
                ? { background: "#eeeeee" }
                : {}),
            }}
          >
            <div className="explore-section-header flex items-center justify-between self-stretch w-full">
              <div className="flex flex-col flex-1 min-w-0">
                <div
                  className={`flex items-end justify-between relative self-stretch w-full flex-[0_0_auto] group-name-parent ${
                    exploreData.length === 1
                      ? is_embedded_in_parent
                        ? "pt-8"
                        : "pt-4"
                      : is_embedded_in_parent
                      ? "pt-4"
                      : "pt-1"
                  }`}
                >
                  <div className="w-[94px] group-name">
                    <span className="text-[var(--wwwstanfordcourtcomblack) font-bebas text-[32px] font-normal leading-8 tracking-normal whitespace-nowrap text-start explore-section-heading">
                      {e.name}
                    </span>
                  </div>
                </div>

                {e.description && (
                  <div className="explore-description">
                    <span>{e.description}</span>
                  </div>
                )}
              </div>

              {/* `/?path=seeAll&title=${e.name}&type=group&apiParams=id=${e.id}` */}
              {exploreData.length > 1 && (
                <div
                  onClick={(ev) => {
                    trackExploreMore({groupName: e.name})
                    handleNavigate(
                      ev,
                      updateQueryParams({
                        path: "seeAll",
                        title: e.name,
                        type: "group",
                        componentParams: `id=${e.id}`,
                      })
                    )}
                  }
                  className="explore-seeAll mr-4 cursor-pointer relative w-fit font-secondary font-normal text-[#666666] text-sm tracking-[0] leading-[16.1px] whitespace-nowrap"
                >
                  <SeeAllButton />
                </div>
              )}
            </div>

            {isFull || exploreData.length === 1
              ? renderFullEventSection(e)
              : renderCompactEventSection(e)}
          </div>
          {showSellAll &&
            isFull &&
            e.event_or_place_list?.length > 0 &&
            renderShowAllButton(e)}
        </>
      );
    },
    [selectedFilter, handleNavigate, exploreData]
  );

  const renderFullEventSection = useCallback(
    (e) => (
      
      <>
        <div className="UI-cards-container justify-between w-full flex max-[500px]:flex-col max-[500px]:flex-nowrap max-[500px]:gap-6 max-[632px]:gap-2 max-[765px]:gap-y-6  gap-6 flex-row flex-wrap">
          {e?.event_or_place_list.length > 0 ? (
            e?.event_or_place_list?.map((k, l) =>
              allowGridCard && k.images?.length > 1 ? (
                <FavoritesGrid
                  key={l}
                  placeName={k.name}
                  data={k}
                  placeType={k.display_category?.label}
                  rating={k.rating}
                  timings=""
                  price=""
                  images={k.images}
                  groupData={getGroupData(e)}
                />
              ) : (
                <SingleCardNew
                  key={l}
                  data={k}
                  size={"full"}
                  boxHeight={"314px"}
                  type={k.type}
                  groupData={getGroupData(e)}
                  parentClassSelector={
                    dimensions?.[e.name]
                      ? `parent-${dimensions[e.name]?.size}-explore-card ${
                          dimensions[e.name]?.additionalClass
                        }`
                      : "parent-full-explore-card"
                  }
                />
              )
            )
          ) : (
            <NoDataFoundSmall />
          )}

          {/* editorial comp of personalized page views  */}
          {/* <Editorial/> */}
        </div>
      </>
    ),
    []
  );

  const renderCompactEventSection = useCallback(
    (e) =>
      dimensions?.[e.name]?.type === "grid" ? (
        <div className="flex flex-col w-full gap-4 grid-container-explore-page overflow-x-scroll">
          {e?.event_or_place_list.length > 0 ? (
            e?.event_or_place_list?.slice(0, 3).map((k, l) => (
              <div className="pr-4 min-w-[360px]">
                <FavoritesGrid
                  key={l}
                  placeName={k.name}
                  data={k}
                  placeType={k.display_category?.label}
                  images={k.images}
                  groupData={getGroupData(e)}
                />
              </div>
            ))
          ) : (
            <NoDataFoundSmall />
          )}
        </div>
      ) : (
        <div className="flex items-start gap-4 self-stretch w-full overflow-x-scroll relative flex-[0_0_auto] min-h-[240px] no-scrollbar pr-[10px] cards-carousel-container">
          {e?.event_or_place_list.length > 0 ? (
            e?.event_or_place_list?.map((k, l) => (
              <SingleCardNew
                key={l}
                data={k}
                size={"small"}
                groupData={getGroupData(e)}
                parentClassSelector={
                  dimensions?.[e.name]
                    ? `parent-${dimensions[e.name]?.size}-explore-card ${
                        dimensions[e.name]?.additionalClass
                      }`
                    : "parent-small-explore-card"
                }
              />
            ))
          ) : (
            <NoDataFoundSmall />
          )}
        </div>
      ),
    []
  );

  const renderShowAllButton = useCallback(
    (e) => (
      <div
        onClick={(ev) =>
          handleNavigate(
            ev,
            updateQueryParams({
              path: "seeAll",
              title: e.name,
              type: "group",
              componentParams: `id=${e.id}`,
            })
          )
        }
        className="w-full flex flex-col gap-2 px-0 pt-10 pb-42 items-center justify-center relative"
      >
        <button className="all-[unset] box-border inline-flex h-[46px] gap-1 px-6 py-2 border-[1.5px] border-solid border-black items-center justify-center relative">
          <button className="all-[unset] box-border relative w-fit font-secondary font-normal text-black text-lg tracking-[0] leading-[20.7px] whitespace-nowrap">
            SHOW ALL EVENTS
          </button>
        </button>
      </div>
    ),
    [handleNavigate]
  );

  return (
    <Home
      nav={"List"}
      showBottomNav={true}
      showPersonalizedButton={false}
      showOldFilter={false}
      isLoading={isLoading}
      showFloatButton={true}
      floatBottonData={{
        parentCss: "absolute bottom-[35px]",
        variant: "map",
        url: updateQueryParams({
          path: "map",
        }),
      }}
    >
      {Object.keys(headerData).length > 0 && (
        <Header
          data={headerData || {}}
          url={`/planner/places-events/groups/${
            apiParams ? "?" + apiParams : ""
          }`}
          setData={setExploreData}
          setNoData={setNoData}
          setIsLoading={setIsLoading}
          filterType="live"
          
        />
      )}
      <div
        className={`explore-page-main-cont w-[100vw] flex flex-col items-start pt-[182px] pb-[100px] px-0 relative bg-white rounded-[48px] overflow-y-scroll places-bg`}
      >
        {isLoading ? (
          <div className="w-full flex justify-center items-center py-10 min-h-[50vh]">
            <Spinner />
          </div>
        ) : combinedRenderList.length > 0 ? (
          <div ref={listContainerRef} className=" w-full max-w-[100vw] min-[1000px]:max-w-[1000px] explore-container">
            {combinedRenderList.slice(0, visibleCount).map((item) => {
              if (item.type === "custom") {
                return (
                  <React.Fragment key={item.key}>
                    {item.component}
                  </React.Fragment>
                );
              }

              return (
                <React.Fragment key={item.key}>
                  {renderExploreSection(item.data, item.index)}
                </React.Fragment>
              );
            })}

            {visibleCount < combinedRenderList.length && (
              <div ref={observerRef} style={{ height: 1 }} />
            )}
          </div>
        ) : (
          noData && <NoDataFoundSmall />
        )}
      </div>
    </Home>
  );
};
